var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakfast = function SvgBreakfast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#breakfast_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M48.75 30.406q-.457 0-.791-.334a1.08 1.08 0 0 1-.334-.79q0-.898.334-1.723.334-.827.984-1.46l1.389-1.406q.668-.667.668-1.6 0-.456.334-.79t.791-.334q.457 0 .791.334t.334.79q0 .898-.334 1.723a4.2 4.2 0 0 1-.984 1.46l-1.389 1.406a2.18 2.18 0 0 0-.668 1.6q0 .456-.334.79a1.08 1.08 0 0 1-.791.334m-6.75 0q-.457 0-.791-.334a1.08 1.08 0 0 1-.334-.79q0-.898.334-1.723.334-.827.984-1.46l1.389-1.406q.668-.667.668-1.6 0-.456.334-.79t.791-.334q.457 0 .791.334t.334.79q0 .898-.334 1.723a4.2 4.2 0 0 1-.984 1.46l-1.389 1.406a2.18 2.18 0 0 0-.668 1.6q0 .456-.334.79a1.08 1.08 0 0 1-.791.334M56.625 33.5q.703 0 1.318.264.615.263 1.073.72.456.458.72 1.073T60 36.875v6.75q0 .703-.264 1.318-.263.615-.72 1.073a3.4 3.4 0 0 1-1.073.72q-.615.264-1.318.264h-1.002a2 2 0 0 0-.053.228.7.7 0 0 1-.07.212v.685q0 1.16-.44 2.18a5.7 5.7 0 0 1-3.005 3.005q-1.02.44-2.18.44h-6.75a5.3 5.3 0 0 1-2.531-.615A5.8 5.8 0 0 1 38.66 51.5h-8.789q-1.16 0-2.18-.44a5.9 5.9 0 0 1-1.793-1.195 5.45 5.45 0 0 1-1.212-1.793 5.6 5.6 0 0 1-.44-2.197V44.75h4.5q0-1.389.527-2.62a6.6 6.6 0 0 1 1.46-2.144 7.3 7.3 0 0 1 2.144-1.459 6.1 6.1 0 0 1 2.62-.527q.525 0 1.019.088.492.088.984.246V31.25h18v2.25zm-21.129 6.75q-.931 0-1.74.352-.81.351-1.441.966-.634.615-.967 1.424a4.8 4.8 0 0 0-.352 1.758H37.5v-4.008a4.6 4.6 0 0 0-.95-.351 5 5 0 0 0-1.054-.141m-5.625 9h7.752a4.8 4.8 0 0 1-.123-1.125V47H26.69q.175.492.492.897.315.404.72.72.405.317.914.457.51.141 1.055.176m8.139 1.178v.017l.017.035v-.017zm15.24-2.303V33.5h-13.5v14.625q0 .703.264 1.318.263.615.72 1.073.458.456 1.073.72t1.318.264h6.75q.703 0 1.318-.264.615-.263 1.073-.72.456-.458.72-1.073t.264-1.318m4.5-4.5v-6.75a1.08 1.08 0 0 0-.334-.791 1.08 1.08 0 0 0-.791-.334H55.5v9h1.125q.457 0 .791-.334a1.08 1.08 0 0 0 .334-.791"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "breakfast_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35466",
    result: "shape"
  })))));
};
export default SvgBreakfast;